/* eslint-disable */
// import lib(s)
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import moment from 'moment';

import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';

import { fetchEnrollmentSearch } from '../../state/PatientEnrollment/PatientEnrollmentActions';

// import custom components
import CustomTextField from '../Common/FormMUIWrapperComponents/CustomTextField';
import CustomSingleSelect from '../Common/FormMUIWrapperComponents/CustomSingleSelect';
// import constants
import { TEXT_FIELD_CONST } from '../Common/FormMUIWrapperComponents/CustomTextField/Constants';
import { SELECT_FIELD_CONST } from '../Common/FormMUIWrapperComponents/CustomSingleSelect/Constants';
import { MASK_3_2_4_NUMBER_PATTERN } from '../Common/MaskUtils/MaskPatterns';

// Import styles
import styles from './PatientSearchForm.css';
import Loading from '../../components/Loading';

const Input = () => <input className={styles.testInput} type="text" />;

const PATIENT_IDENTIFIER = [
  { value: 'mrn', label: 'MRN' },
  { value: 'ssn', label: 'SSN' },
  { value: 'ssnLastFour', label: 'SSN (last 4)' },
  { value: 'dob', label: 'Date Of Birth' },
];

const PatientSearchForm = () => {
  const dispatch = useDispatch();
  const identifiersData = useSelector(
    state => state.idtfPatientEnrollment.patientEnrollment.searchIdentifiers,
  );

  const isSearching = useSelector(
    state => state.idtfPatientEnrollment.patientEnrollment.isSearching,
  );

  const isEdit = useSelector(
    state => state.idtfPatientEnrollment.patientEnrollment.enrollEditMode,
  );
  // useEffect(()=> {
  //   if(identifiersData && identifiersData.mrn) {
  //     setMrnSelected(true)
  //   } else if(identifiersData && identifiersData.ssn) {
  //     setSsnSelected(true)
  //   } else if(identifiersData && identifiersData.dob) {
  //     setDobSelected(true)
  //   } else if(identifiersData && identifiersData.ssnLastFour) {
  //     setSsnLastFourSelected(true)
  //   }
  // }, [])

  const [formData, setFormData] = useState({
    lastName: '',
    firstName: '',
    middleName: '',
    patientIdentifier: { value: 'mrn', label: 'MRN' },
    dob: '',
    ssn: '',
    ssnLastFour: '',
    mrn: '',
  });

  const handleSearch = () => {
    dispatch(fetchEnrollmentSearch(formData));
    setSearchAgain(true);
  };

  // state for keyboard input in datepicker
  const [selectedDate, handleDateChange] = useState(null)

  const [mrnSelected, setMrnSelected] = useState(true);
  const [ssnSelected, setSsnSelected] = useState(false);
  const [dobSelected, setDobSelected] = useState(false);
  const [ssnLastFourSelected, setSsnLastFourSelected] = useState(false);

  const [searchAgain, setSearchAgain] = useState(false);

  const INVALID_SSN = 'Invalid SSN';

  const handleFormDataUpdate = (e, stateKey, val) => {
    const { value } = e.target;
    if (stateKey) {
      const tempFormData = { ...formData };
      switch (stateKey) {
        case 'patientIdentifier':
          let selectedPI = PATIENT_IDENTIFIER.find(o => o.value === value);
          if (selectedPI) {
            tempFormData[stateKey] = selectedPI;
            if (value === 'mrn') {
              (tempFormData['dob'] = ''),
                (tempFormData['ssn'] = ''),
                (tempFormData['ssnLastFour'] = ''),
                handleDateChange(null);
                setMrnSelected(true);
              setSsnSelected(false);
              setSsnLastFourSelected(false);
              setDobSelected(false);
            } else if (value === 'ssn') {
              (tempFormData['dob'] = ''),
                (tempFormData['ssnLastFour'] = ''),
                (tempFormData['mrn'] = ''),
                handleDateChange(null);
                setMrnSelected(false);
              setSsnSelected(true);
              setSsnLastFourSelected(false);
              setDobSelected(false);
            } else if (value === 'ssnLastFour') {
              (tempFormData['dob'] = ''),
                (tempFormData['ssn'] = ''),
                (tempFormData['mrn'] = ''),
                handleDateChange(null);
                setMrnSelected(false);
              setSsnSelected(false);
              setSsnLastFourSelected(true);
              setDobSelected(false);
            } else if (value === 'dob') {
              (tempFormData['ssn'] = ''),
                (tempFormData['ssnLastFour'] = ''),
                (tempFormData['mrn'] = ''),
                setMrnSelected(false);
              setSsnSelected(false);
              setSsnLastFourSelected(false);
              setDobSelected(true);
            }
          }
          break;
        case 'dob':
          if (e) {
            tempFormData[stateKey] = new Date(e);
          }
          break;
        case 'lastName':
        case 'firstName':
        case 'middleName':
        case 'ssn':
        case 'ssnLastFour':
        case 'mrn':
          tempFormData[stateKey] = value;
          break;
        default:
          break;
      }
      setFormData(tempFormData);
    }
  };

  // validate socialSecurityNumber length
  const validateSSN = e => {
    let valid = true;
    let value = '';
    if (e && e['target']) {
      value = e.target.value;
    } else if (e && !e.target) {
      value = e;
    }
    if (value) {
      const ssnStr = value.replaceAll('-', '');
      if (ssnStr.length === 9) {
        valid = true;
      } else {
        valid = false;
      }
    }
    return valid;
  };

  const handleDOBChange = date => {
    const tempFormData = { ...formData };
    tempFormData['dob'] = moment(date).format('MM-DD-YYYY');
    setFormData(tempFormData);
    handleDateChange(date)
  };

  const handleSubmit = e => {
    e.preventDefault && e.preventDefault();
    // console.log("Search Form Submitted => ",formData)
  };

  useEffect(() => {
    // console.log('formData >>>>> ', formData);
  }, [formData]);

  return (
    <div className={styles.pageContainer}>
      <h1 className={styles.title}>
        {' '}
        {isEdit ? 'Patient Information' : 'Search'}
      </h1>
      <Grid container spacing={5}>
        {/* ============= Start of Grid ============= */}
        {/* Basic Details section */}
        <Grid item xs={2}>
          <CustomSingleSelect
            label="MRN, SSN or DOB"
            placeholder="Select Identifier"
            variant={SELECT_FIELD_CONST.VARIANT.OUTLINED}
            menuItems={PATIENT_IDENTIFIER}
            valueKey="value"
            labelKeys={['label']}
            mandatory={true}
            selectedValue={formData.patientIdentifier}
            stateKey="patientIdentifier"
            // validateForm={validateForm}
            handleChange={handleFormDataUpdate}
          />
        </Grid>
        <Grid
          style={
            dobSelected
              ? { marginLeft: '-42px', marginTop: '16px' }
              : { marginLeft: '-42px', marginTop: '20px' }
          }
          item
          xs={2}
        >
          {mrnSelected && (
            <div style={{ width: '200px' }}>
              <CustomTextField
                placeholder="Enter MRN"
                size={TEXT_FIELD_CONST.SIZE.SMALL}
                value={formData.mrn}
                stateKey="mrn"
                onChange={handleFormDataUpdate}
              />
            </div>
          )}
          {ssnSelected && (
            <div style={{ width: '200px' }}>
              <CustomTextField
                placeholder="000-00-0000"
                maskInput={MASK_3_2_4_NUMBER_PATTERN}
                size={TEXT_FIELD_CONST.SIZE.SMALL}
                value={formData.ssn}
                stateKey="ssn"
                errorText={INVALID_SSN}
                validation={validateSSN}
                onChange={handleFormDataUpdate}
              />
            </div>
          )}
          {ssnLastFourSelected && (
            <div style={{ width: '200px' }}>
              <CustomTextField
                style={{ width: '200px' }}
                placeholder="0000"
                size={TEXT_FIELD_CONST.SIZE.SMALL}
                value={formData.ssnLastFour}
                stateKey="ssnLastFour"
                onChange={handleFormDataUpdate}
              />
            </div>
          )}
          {dobSelected && (
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                autoOk
                disableFuture
                style={{ marginTop: '8px', width: '200px' }}
                openTo="year"
                variant="inline"
                size="small"
                inputVariant="outlined"
                format="MM-dd-yyyy"
                margin="normal"
                placeholder="MM-DD-YYYY"
                id="dob"
                views={['year', 'month', 'date']}
                value={selectedDate}
                onChange={date => {
                  handleDOBChange(date);
                }}
                inputVariant="outlined"
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
                fullWidth
              />
            </MuiPickersUtilsProvider>
          )}
        </Grid>
        <Grid item xs={8}>
          {/* Empty space as per figma */}
        </Grid>
        <Grid item xs={4}>
          <CustomTextField
            label="First Name"
            placeholder="Enter First Name"
            size={TEXT_FIELD_CONST.SIZE.SMALL}
            value={formData.firstName}
            stateKey="firstName"
            onChange={handleFormDataUpdate}
          />
        </Grid>
        <Grid item xs={4}>
          <CustomTextField
            label="Middle Name or Initial"
            placeholder="Enter Middle Name or Initial"
            size={TEXT_FIELD_CONST.SIZE.SMALL}
            value={formData.middleName}
            stateKey="middleName"
            onChange={handleFormDataUpdate}
          />
        </Grid>
        <Grid item xs={4}>
          <CustomTextField
            label="Last Name"
            mandatory={true}
            placeholder="Enter Last Name"
            size={TEXT_FIELD_CONST.SIZE.SMALL}
            value={formData.lastName}
            stateKey="lastName"
            onChange={handleFormDataUpdate}
          />
        </Grid>
        <Grid item xs={8}>
          {/* Empty space as per figma */}
        </Grid>
        <Grid item xs={10}>
          {/* Empty space as per figma */}
        </Grid>
        <Grid item xs={2}>
          {/* <button
            type="button"
            className={styles.PrimaryButton}
            onClick={handleSubmit}
          >
            SEARCH AGAIN
          </button> */}
          {isSearching ? (
            <button
              type="button"
              disabled
              className={styles.PrimaryButtonDisabled}
            >
              <Loading />
            </button>
          ) : searchAgain ? (
            <button
              type="button"
              className={
                !(
                  formData.lastName &&
                  (formData.mrn ||
                    formData.dob ||
                    formData.ssn ||
                    formData.ssnLastFour)
                )
                  ? styles.PrimaryButtonDisabled
                  : styles.PrimaryButton
              }
              onClick={handleSearch}
            >
              SEARCH AGAIN
            </button>
          ) : (
            <button
              type="button"
              className={
                !(
                  formData.lastName &&
                  (formData.mrn ||
                    formData.dob ||
                    formData.ssn ||
                    formData.ssnLastFour)
                )
                  ? styles.PrimaryButtonDisabled
                  : styles.PrimaryButton
              }
              onClick={handleSearch}
              // disabled={!(formData.lastName && (formData.mrn || formData.dob || formData.ssn || formData.ssnLastFour))}
            >
              CONTINUE
            </button>
          )}
        </Grid>
        {/* ============= End of Grid ============= */}
      </Grid>
    </div>
  );
};

export default PatientSearchForm;



// WEBPACK FOOTER //
// ./src/views/components/PatientSearchForm/PatientSearchForm.jsx